var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_2690",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_2690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.375 42.875L46.625 39.125C47.0833 38 47.4271 36.8854 47.6562 35.7812C47.8854 34.6771 48 33.5833 48 32.5C48 27.6667 46.2917 23.5417 42.875 20.125C39.4583 16.7083 35.3333 15 30.5 15C29.5 15 28.4375 15.1042 27.3125 15.3125C26.1875 15.5208 25.0208 15.8542 23.8125 16.3125L20.0625 12.5625C21.6458 11.7292 23.3229 11.0938 25.0938 10.6562C26.8646 10.2188 28.6667 10 30.5 10C33 10 35.4479 10.4167 37.8438 11.25C40.2396 12.0833 42.5 13.2917 44.625 14.875L48.125 11.375L51.625 14.875L48.125 18.375C49.7083 20.5 50.9167 22.7604 51.75 25.1562C52.5833 27.5521 53 30 53 32.5C53 34.25 52.7812 35.9896 52.3438 37.7188C51.9062 39.4479 51.25 41.1667 50.375 42.875ZM33 25.5V20H28V20.5L33 25.5ZM50 56.5L44 50.5C42 51.9583 39.8438 53.0729 37.5312 53.8438C35.2188 54.6146 32.875 55 30.5 55C27.4167 55 24.5104 54.4062 21.7812 53.2188C19.0521 52.0312 16.6667 50.4167 14.625 48.375C12.5833 46.3333 10.9688 43.9479 9.78125 41.2188C8.59375 38.4896 8 35.5833 8 32.5C8 30 8.38542 27.5938 9.15625 25.2812C9.92708 22.9688 11.0417 20.875 12.5 19L4 10.5L7.5 7L53.5 53L50 56.5ZM30.5 50C32.25 50 33.9583 49.7292 35.625 49.1875C37.2917 48.6458 38.8542 47.875 40.3125 46.875L16 22.5625C15 24.0208 14.25 25.5833 13.75 27.25C13.25 28.9167 13 30.6667 13 32.5C13 37.3333 14.7083 41.4583 18.125 44.875C21.5417 48.2917 25.6667 50 30.5 50ZM23 7.5V2.5H38V7.5H23Z",
    fill: "#5776E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerOff);
export default __webpack_public_path__ + "static/media/timer_off.ff71813d5c6abc43d5c822f2ea39d500.svg";
export { ForwardRef as ReactComponent };